module.exports = __webpack_public_path__ + "img/2500m.ad8801ce.png";